import {ComputedOptions} from "~knockout/index";
import {getPrimaryScreenObservable, getSecondaryScreenObservable} from "./ScreenManager";

/**
 * get computed visibility options for primary screens
 */
export function getPrimaryScreenVisibilityOptions(primaryID: string) : ComputedOptions<boolean>
{
    var options: ComputedOptions<boolean>;

    options =
    {
        read: () : boolean =>
              {
                  return getPrimaryScreenObservable()() === primaryID;
              }
    };

    return options;
}


/**
 * get computed visibility options for secondary screens
 */
export function getSecondaryScreenVisibilityOptions(primaryID: string, secondaryID: string) : ComputedOptions<boolean>
{
    var options: ComputedOptions<boolean>;

    options =
    {
        read: () : boolean =>
              {
                  return getPrimaryScreenObservable()() === primaryID && getSecondaryScreenObservable()() === secondaryID;
              }
    };

    return options;
}



// WEBPACK FOOTER //
// ./src/ts/screens/ScreenVisibility.ts